import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React, { useState, useEffect, useRef } from 'react';
import * as _ from "../../../util/lodash";
import PropTypes from 'prop-types';
import { getContext } from 'react-recompose';
import { positions, sizes } from "../../../enums";
import { toUIProps } from "../../../util";
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import cx from 'classnames';
import evalPredicate from "../../../util/eval-predicate";
import ResizeHandle from "../../common/ResizeHandle";
import ErrorIcon from "../../abstractions/error-icon";
import Label from "../label";
var propMap = {
  handleChange: 'onChange',
  hasFocus: 'focus',
  isDisabled: 'disabled',
  isFluid: 'fluid',
  isTransparent: 'transparent',
  isInverted: 'inverted',
  isResizable: 'resizable'
};
var ADDED_PROPS = ['errorMessage', 'handleChange', 'hasError', 'hasFocus', 'isDisabled', 'isFluid', 'isTransparent', 'isInverted', 'isResizable', 'label', 'maxChars', 'textAreaValue', 'setTextAreaValue', 'handleChange', 'onChange', 'value'];
var MODIFIED_PROPS = ['error'];
var UNSUPPORTED_PROPS = ['as', 'children', 'className', 'disabled', 'error', 'focus', 'fluid', 'inverted', 'textarea', 'labelPosition', 'loading', 'transparent'];

var TextArea = function TextArea(props) {
  var _useState = useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var handleChange = function handleChange(e) {
    var value = e.target.value || '';
    if (props.onChange) props.onChange(e, {
      value: value,
      id: props.id
    }); // All our handlers have this signature
  };

  var handleClick = function handleClick(e) {
    var value = e.target.value || '';
    props.onClick && props.onClick(e, {
      value: value,
      id: props.id
    });
  };

  var handleFocus = function handleFocus(e) {
    setFocus(true);
    var value = e.target.value || '';
    props.onFocus && props.onFocus(e, {
      value: value,
      id: props.id
    });
  };

  var handleBlur = function handleBlur(e) {
    setFocus(false);
    var value = e.target.value || '';
    props.onBlur && props.onBlur(e, {
      value: value,
      id: props.id
    });
  };

  var UIProps = toUIProps({
    props: props,
    propMap: propMap,
    MODIFIED_PROPS: MODIFIED_PROPS,
    UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
    ADDED_PROPS: ADDED_PROPS
  });
  var resizableDivRef = useRef();

  var _useState2 = useState(false),
      isResizing = _useState2[0],
      setIsResizing = _useState2[1];

  var _useState3 = useState(0),
      prevY = _useState3[0],
      setPrevY = _useState3[1];

  var _useState4 = useState(),
      componentHeight = _useState4[0],
      setComponentHeight = _useState4[1]; //builds out the object for 'remaining characters'


  if ( // we need to perform a different check for the maxChars it's an object
  _.isObject(props.maxChars) ? props.maxChars.content !== null && props.maxChars.content !== undefined : props.maxChars !== null) {
    var _cx;

    UIProps.maxLength = _.isObject(props.maxChars) ? props.maxChars.content : props.maxChars || 0;
    var remainingChars = UIProps.maxLength - calcLength(props.value);
    var remainingCharsLabel = /*#__PURE__*/React.createElement(Label, {
      text: remainingChars.toString()
    });

    var remainingCharsLabelPosition = _.get(props.maxChars, 'position', positions.RIGHT);

    var remainingCharsClassNames = cx((_cx = {
      'max-char': 'max-char',
      'max-char-warning': _.inRange(remainingChars, 4, 11),
      'max-char-error': remainingChars <= 3
    }, _cx[remainingCharsLabelPosition] = remainingCharsLabelPosition, _cx));
    UIProps.remainingCharCount = /*#__PURE__*/React.createElement("div", {
      className: remainingCharsClassNames
    }, remainingCharsLabel);
    UIProps.remainingCharCountPosition = remainingCharsLabelPosition;
  }

  var taClasses = cx('ui', UIProps.size, UIProps.disabled && 'disabled', UIProps.resizable && 'resizable', UIProps.focus && 'focus', UIProps.inverted && 'inverted', UIProps.labelPosition && UIProps.labelPosition !== true && UIProps.labelPosition + ' labeled' || UIProps.label && 'labeled', UIProps.remainingCharCountPosition && UIProps.remainingCharCountPosition !== true && UIProps.remainingCharCountPosition + ' labeled' || UIProps.remainingCharCount && 'labeled', UIProps.loading && 'loading', UIProps.transparent && 'transparent', 'textarea', 'resize-textarea__wrapper', {
    focus: props.hasFocus === null && focus
  });
  var wrapperClassName = cx('ck textarea', {
    fluid: props.isFluid,
    error: evalPredicate(props.hasError) || !!props.errorMessage
  }); //handle the resize and event attaching and detaching

  var handleResizeStart = function handleResizeStart(event) {
    setIsResizing(true);
    setPrevY(event.clientY);
  };

  useEffect(function () {
    var handleResizeStop = function handleResizeStop() {
      setIsResizing(false);
    }; //calculate the height by also enforcing the min/max resize height


    var handleResizeMove = function handleResizeMove(event) {
      if (isResizing) {
        //calculate the new size with considerations for a 32px lower limit
        var height = Math.max( //32px (31.5px to be exact) is the lower limit that the text area and inputs can tolerate
        32, //look for the potential new height of the textarea
        resizableDivRef.current.offsetHeight + (event.clientY - prevY)); //once calculated, set the textarea wrapper to the new size

        setComponentHeight(height);
        setPrevY(event.clientY);
      }
    }; //track event mouse dragging


    if (isResizing) {
      document.addEventListener('mousemove', handleResizeMove);
      document.addEventListener('mouseup', handleResizeStop);
    }

    return function () {
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeStop);
    };
  }, [isResizing, prevY]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    style: props.style
  }, props.label ? /*#__PURE__*/React.createElement(Label, {
    text: props.label
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "error-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: taClasses,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onClick: handleClick,
    ref: resizableDivRef,
    style: {
      height: componentHeight + "px",
      maxHeight: componentHeight + "px"
    }
  }, UIProps.labelPosition === 'left' && UIProps.label, UIProps.remainingCharCountPosition === 'left' && UIProps.remainingCharCount, /*#__PURE__*/React.createElement("textarea", {
    placeholder: UIProps.placeholder,
    onChange: handleChange,
    value: props.value,
    ref: props.innerRef,
    style: {
      height: componentHeight - 10 + "px",
      maxHeight: componentHeight - 10 + "px"
    }
  }), UIProps.labelPosition !== 'left' && UIProps.label, UIProps.remainingCharCountPosition !== 'left' && UIProps.remainingCharCount, props.isResizable && !props.isDisabled ? /*#__PURE__*/React.createElement(ResizeHandle, {
    onMouseDown: handleResizeStart
  }) : null), /*#__PURE__*/React.createElement(ErrorIcon, {
    errorMessagePosition: props.errorMessagePosition,
    errorMessage: props.errorMessage
  })));
};

TextArea.propTypes = {
  label: PropTypes.string,
  maxChars: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    content: PropTypes.number,
    position: PropTypes.oneOf(positions.LR)
  })]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  hasFocus: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  isFluid: PropTypes.bool,
  isTransparent: PropTypes.bool,
  isResizable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  errorMessage: PropTypes.string,
  errorMessagePosition: PropTypes.oneOf(positions.ALL),
  size: PropTypes.oneOf(sizes.ALL),
  placeholder: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  innerRef: PropTypes.func
};
TextArea.defaultProps = {
  label: null,
  hasError: false,
  hasFocus: null,
  isDisabled: false,
  isFluid: true,
  isTransparent: false,
  isResizable: false,
  errorMessage: null,
  errorMessagePosition: positions.TOP_LEFT,
  size: sizes.X5,
  placeholder: '',
  maxChars: null,
  onChange: null,
  onClick: null,
  onBlur: null,
  onFocus: null,
  value: '',
  id: undefined,
  innerRef: undefined
};

var calcLength = _.memoize(function (str) {
  var urlRegExp = RegExp(/(https?:\/\/)([-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?)((\/[%\-\w]+(\.\w{2,})?)*(([\w\-\.\?\\\/+@&#;`~=%!]*)(\.\w{2,})?)*\/)?/g);
  var twitLinkLength = 23;
  var linkMatch = str.match(urlRegExp) || [];
  var linkCount = linkMatch.length;

  var yourLinkLength = _reduceInstanceProperty(_).call(_, linkMatch, function (count, l) {
    return l.length + count;
  }, 0);

  return str.length - yourLinkLength + linkCount * twitLinkLength;
}, function (str) {
  return "cache-" + str;
});

export var PrivateTextArea = TextArea;
export default compose(removeProps(['transparent', 'size']), whitelistStyles(), getContext({
  isInverted: PropTypes.bool
}))(TextArea);
//# sourceMappingURL=index.js.map